import { render } from "./ProjectDetails.vue?vue&type=template&id=4da534df"
import script from "./ProjectDetails.vue?vue&type=script&lang=js"
export * from "./ProjectDetails.vue?vue&type=script&lang=js"

import "./ProjectDetails.vue?vue&type=style&index=0&id=4da534df&lang=scss"

import exportComponent from "D:\\DOWNLOAD\\vue\\portfolio_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__